import type { Light } from './renderer/renderer'

/**
 * The backlight coming from `angle` (radians on screen; 0 = right, -π/2 = top).
 * `crescentWidth` is the crescent's thickness at its widest, as a fraction of
 * the globe's radius: the sun sits that far behind the planet's edge.
 */
export function lightAt(angle: number, crescentWidth: number): Light {
  const ce = 1 - crescentWidth
  return { lx: Math.cos(angle), ly: Math.sin(angle), ce, se: Math.sqrt(1 - ce * ce) }
}
